export * from './SessionRecorderBrowserTraceExporter';
//# sourceMappingURL=index-browser.js.map